import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {OrderControllerService} from "@aparraga/ahoracrypto-api-sdk/sdk";
import {EncryptorService} from "@aparraga/ahoracrypto-client-common/src/app/common/encryptor/encryptor.service";
import {CustomValidators} from "@aparraga/ahoracrypto-client-common/src/app/common/validators/custom.validators";
import {DOCUMENT} from "@angular/common";
import {I18nServices} from "@aparraga/ahoracrypto-client-common/src/app/common/i18n/i18n.service";

import { Modal } from 'flowbite';

@Component({
    templateUrl: './showmnemonics.component.html',
    styleUrls: ['./showmnemonics.component.scss'],
    selector: 'showmnemonics',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ShowMnemonicsComponent implements AfterViewInit {

  public _order: any;
  get order(): string {
    return this._order;
  }
  @Input() set order(value: any) {
    this._order = value;
  }

  @Input() secret: string = null;

  @ViewChild('showMnemonicsModal') protected showMnemonicsModal: ElementRef<HTMLElement>;


  protected modal;

  public step = 1;

  public showAcceptTouError = false;


  protected understoodChecked = false;

  @ViewChild('understoodCheckbox') understoodCheckbox: ElementRef;

  public checked;

  public language;

  public base64MnemonicImageStr;

  public constructor(protected orderControllerService: OrderControllerService,
                     protected encryptorService: EncryptorService,
                     protected renderer: Renderer2,
                     protected i18nService: I18nServices,
                     protected customValidators: CustomValidators,
                     @Inject(DOCUMENT) private document: Document) {

    this.language = this.i18nService.getLanguageIsoCode();

  }

  ngAfterViewInit() {
    this.modal = new Modal(this.showMnemonicsModal.nativeElement, {
      backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0',
      onShow: () => {
        this.document.body.classList.add('on-modal');
      },
      onHide: () => {
        this.document.body.classList.remove('on-modal');
      }
    });
  }


  show() {
    this.step = 1;
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  public updateAcceptTou() {
    if(!this.understoodChecked) {
      this.understoodChecked = true;
      this.renderer.addClass(this.understoodCheckbox.nativeElement, 'accepted-checkbox');
    }
    else {
      this.understoodChecked = false;
      this.renderer.removeClass(this.understoodCheckbox.nativeElement, 'accepted-checkbox');
    }
    this.showAcceptTouError = !this.understoodChecked;
  }

  public continueWithNextStep() {
    if(this.step < 3 && !this.understoodChecked) {
      this.showAcceptTouError = true;
    }
    else {
      this.goToStep(this.step + 1);
    }
  }

  public goToStep(stepNumber) {
    this.step = stepNumber;
    this.understoodChecked = false;
    this.showAcceptTouError = false;
    if(this.step <= 27) {
      if(this.step >= 3 && this.step <= 26) {
        this.showMnemonic(this.step - 3);
      }
    }
    else {
      this.hide();
    }
  }

  public showMnemonic(mnemonicNumber) {
    if(this.secret != null) {

      this.orderControllerService.orderControllerGetOneSingleOrderMnemonic(this._order.id, mnemonicNumber).subscribe(imageEmcrypted => {
        let base64Image = this.encryptorService.readFromCipherText(imageEmcrypted, this.secret);
        if(base64Image != null) {
          this.base64MnemonicImageStr = `data:image/png;base64,${base64Image}`;
        }
      });

    }
  }

}
